import React from "react";
import {useStores} from "../../stores";
import {Navigate, useLocation} from "react-router";
import {routes} from "../../routing/routes";
import {environment} from "../../env";
import {buildLoginRouteState} from "./LoginRouteState";
import {RequireAuthWithAuth0} from "./RequireAuthWithAuth0";


export type Props = {
    children?: React.ReactNode
}

/**
 * https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f
 */
export const RequireAuth: React.FC<Props> = ({children}) => {
    const {authStore} = useStores();
    const location = useLocation();
    const loggedIn = authStore.isLoggedIn();

    if (loggedIn) {
        return <>{children}</>;
    }

    if (environment.hasAuth0) {
        return <RequireAuthWithAuth0 />;
    }

    const loginUrl = routes.login;
    return <Navigate
        to={loginUrl}
        replace
        state={buildLoginRouteState(location, location.pathname !== loginUrl)}
    />;
}
